module.exports = __webpack_public_path__ + "static/media/halloween-kidspack-mb-fr.c1a649e6.jpg";